import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Calendar, Phone, Info } from 'lucide-react';
export function PermitToCarry() {
  useDocumentMeta('Minnesota Permit to Carry Classes | Kjergaard Sports', 'Information on Minnesota Permit to Carry classes offered at Kjergaard Sports in Lake Benton, Minnesota.');
  return <div data-id="element-469">
      <PageHero title="Minnesota Permit to Carry Classes" image="https://drwzpk38qkpfb.cloudfront.net/www.ksportsllc.com/uploaded/images/events.jpg?opt=w3" alt="Kjergaard Sports event and in-store display" data-id="element-470" />

      <section className="py-20 bg-brand-offwhite" data-id="element-471">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-472">
          <Calendar className="w-12 h-12 text-brand-hunter mx-auto mb-6" data-id="element-473" />
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-474">
            Class Information
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-475">
            Kjergaard Sports periodically hosts Minnesota Permit to Carry
            classes. These in-person sessions cover essential safety
            fundamentals, legal requirements, and practical instruction for
            responsible carry.
          </p>

          <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-10 text-left" data-id="element-476">
            <div className="flex items-start" data-id="element-477">
              <Info className="w-6 h-6 text-brand-leather mr-4 flex-shrink-0 mt-1" data-id="element-478" />
              <div data-id="element-479">
                <h3 className="font-serif text-xl mb-2" data-id="element-480">Schedule Updates</h3>
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-481">
                  Class dates change. Please call Kjergaard Sports or follow our
                  Facebook page for the current class schedule and registration
                  details.
                </p>
              </div>
            </div>
          </div>

          <a href="tel:507-368-4696" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-482">
            <Phone className="w-5 h-5 mr-2" data-id="element-483" />
            Call for Upcoming Class Dates
          </a>
        </div>
      </section>
    </div>;
}